var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.articleLabels && _vm.articleLabels.length)?_c('div',{staticClass:"cascader"},[(_vm.app_type == 'man' || _vm.item.invisibleStatus !== 4)?_c('el-cascader',{ref:"countrySelectRef",staticClass:"select-role",attrs:{"options":_vm.articleLabels,"value":_vm.labelValue,"props":{
      multiple: false,
      value: 'id',
      label: 'name',
      children: 'contentLabels',
      checkStrictly: true,
      disabled: 'disableSelected',
    }},on:{"change":_vm.handleChange},scopedSlots:_vm._u([{key:"default",fn:function({ node, data }){return [_c('el-tooltip',{staticClass:"item",attrs:{"disabled":data.name.length < 18,"effect":"dark","content":data.name,"placement":"top"}},[_c('span',[_vm._v(_vm._s(data.name))])])]}}],null,false,680739697)}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }